module.exports = __webpack_public_path__ + "img/plane512.6d68feda.png";